import { Space } from "@mantine/core";
import React, { useState } from "react";
import CategoryTreeDownloadButton from "@/components/admin/categoryManagement/CategoryTreeDownloadButton";
import PageHeader from "@/components/admin/header/PageHeader";
import { useCategoryTrees } from "@/hooks/useCategoryTrees";
import { CategoryTreeService } from "@/services/categoryTree/categoryTree.service";
import { downloadCsv } from "@/utils/csv";
import { showError } from "@/utils/notification";

const CategoryDownloadPage: React.FC = () => {
  const [isDownloading, setIsDownloading] = useState(false);
  const { categoryTrees, getCategoryTreeVersion } = useCategoryTrees();

  const handleDownloadCategoryTree = async (categoryTreeId: string) => {
    try {
      setIsDownloading(true);
      const data = await CategoryTreeService.download(categoryTreeId);
      const fileName = `category_${getCategoryTreeVersion(categoryTreeId)}.csv`;
      downloadCsv(data, fileName);
      setIsDownloading(false);
    } catch (error) {
      console.error(error);
      showError("ダウンロードに失敗しました。");
    }
  };

  return (
    <>
      <PageHeader hasBack={false} title="カテゴリファイルダウンロード" />
      <CategoryTreeDownloadButton
        categoryTrees={categoryTrees || []}
        handleDownload={handleDownloadCategoryTree}
        isDownloading={isDownloading}
      />
      <Space h="100px" />
    </>
  );
};

export default CategoryDownloadPage;
